<!--
 * @Author: hookshuang
 * @Date: 2022-03-23 17:53:06
 * @LastEditTime: 2022-03-24 18:52:13
 * @FilePath: /zhulogic-design-cloud-next/src/views/redirect/index.vue
 * @Description: 识别报价中转页面
-->

<template>
  <div class="redirect">
    <div>
      <img src="@/assets/new-global.gif" />
      <div class="_label">正在处理数据，请稍候...</div>
    </div>
  </div>
</template>
<script >
import axios from "axios";
import Cookie from "js-cookie";
const token = Cookie.get("ZHULOGIC_TOKEN");
export default {
  data() {
    return {
      loading: true,
      isToken: !!token,
      nextUrl: process.env.VUE_APP_NEXT_BASIC_URL,
      design2dUrl: process.env.VUE_APP_2D_URL,
    };
  },
  beforeCreate() {
    this.$store.dispatch("actiontipshow", false);
  },
  created() {
    this.loadRouteData();
    this.loadCode();
  },
  methods: {
    // 跳转2d工具的参数
    loadCode() {
      let toolUrl = this.$route.query.t;
      if (!toolUrl) {
        return;
      }
      if (!this.isToken) {
        window.location.href = this.nextUrl + "/sign";
      } else {
        axios.get("/designer_api/user/authorize").then((res) => {
          const _url = this.design2dUrl + res;
          window.location.href = _url;
        });
      }
    },
    loadRouteData() {
      let pinUrl = this.$route.query.u;
      if (!pinUrl) {
        return;
      }
      axios
        .post(`/designer_api/files/uploadProductImageByUrl`, { url: pinUrl })
        .then((val) => {
          axios
            .post(`/designer_api/product_ai/detect_url?imageUrl=${val.key}`)
            .then((res) => {
              this.$ls.set("identifyImages", [
                {
                  ...res,
                  ...{
                    id: val.id,
                    key: val.key,
                    height: val.height,
                    width: val.width,
                    clipOssLists: [],
                  },
                },
              ]);
              this.$router.push({ name: "Clipping" });
            });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.redirect {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  img {
    width: 160px;
  }
}
</style>